import { Controller } from "@hotwired/stimulus"

// "← Back" that returns to the previous page the user came from instead of a
// fixed destination. Pops browser history when there is any to pop; otherwise
// falls through to the anchor's href fallback (deep link / direct load).
export default class extends Controller {
  back(event) {
    if (window.history.length > 1) {
      event.preventDefault()
      window.history.back()
    }
  }
}
